import { computed, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import checkHook from "./checkHook";
import { PUSH_ANSWER_LIST } from "../store/modules/survey/mutations";
import {
  commonAnswerInfo,
  singleEditInfo,
  collectInfo,
  checkTips,
} from "./answerHook";
import {
  BACK_PREV_QUESTION,
  GO_NEXT_QUESTION,
} from "../store/modules/survey/actions";
import { getParam, setCookie } from "../utils";
import { submitQuestion } from "../api/survey";
import { clearLocalData, loadAnswerStartTime } from "./historyHook";
import { SET_UID } from "../store/modules/user/mutations";
import { popupState } from "./popupHook";
import singleChoose from "../components/questionType/Choose.vue";
import multipleChoose from "../components/questionType/Choose.vue";
import cloze from "../components/questionType/Cloze.vue";
import messageCollect from "../components/questionType/MessageCollect.vue";
import matrixSingle from "../components/questionType/Matrix.vue";
import matrixProgress from "../components/questionType/Matrix.vue";
import NPS from "../components/questionType/NPS.vue";
import { language } from "../language";
export default function () {
  const { checkMap } = checkHook();
  const store = useStore();
  const router = useRouter();
  const routeMap = {
    singleChoose,
    multipleChoose,
    cloze,
    messageCollect,
    matrixSingle,
    matrixProgress,
    NPS,
  };
  const currentIndex = computed(() => store.state.survey.currentIndex);
  const surveyStartTime = computed(() => store.state.survey.surveyStartTime);
  const questionList = computed(() => store.state.survey.questionList);
  const enterQuestionTime = computed(
    () => store.state.survey.enterQuestionTime
  );
  // 当前题目的选项配置
  const currentAnswerConfig = computed(
    () => store.getters["survey/currentAnswerConfig"]
  );
  // 当前的题目类别
  const currentType = computed(
    () => store.getters["survey/currentQuestionType"]
  );
  // 当前题目的问卷结果处理类型
  const currentResultType = computed(
    () => store.getters["survey/currentResultType"]
  );
  const currentValidQuestionIndex = computed(
    () => store.getters["survey/currentValidQuestionIndex"]
  );
  const prevQuestionIndex = computed(
    () => store.getters["survey/prevQuestionIndex"]
  );
  const currentCommonResult = computed(
    () => store.getters["survey/currentCommonResult"]
  );
  // 获取多选限制信息
  const isMultipleChooseAndLimit = computed(() => {
    let isMultipleChoose = currentType.value === "multipleChoose";
    let maxChooseCount = currentAnswerConfig.value?.maxChooseCount || 0;
    let minChooseCount = currentAnswerConfig.value?.minChooseCount || 0;
    return {
      isMultipleChoose,
      maxChooseCount,
      minChooseCount,
    };
  });
  const showLimitCount = computed(() => store.getters["survey/showLimitCount"]);
  const questionTitleTypeMap = {
    singleChoose: "singleChoose",
    multipleChoose: "multiChoose",
    cloze: "hide",
    messageCollect: "hide",
    matrixSingle: "hide",
    matrixProgress: "hide",
    NPS: "score",
  };
  const questionTitleType = computed(() => {
    return questionTitleTypeMap[currentType.value];
  });

  const currentComponent = computed(() => {
    return routeMap[currentType.value];
  });
  const commitAnswerMap = {
    common: () => {
      store.commit(
        `survey/${PUSH_ANSWER_LIST}`,
        Object.assign(currentCommonResult.value, {
          answerChoose: Object.assign(commonAnswerInfo.value),
        })
      );
    },
    cloze: () => {
      store.commit(
        `survey/${PUSH_ANSWER_LIST}`,
        Object.assign(currentCommonResult.value, {
          answerSingleEdit: singleEditInfo.value,
        })
      );
    },
    messageCollect: () => {
      let params = {};
      if (collectInfo.value?.phone?.length) {
        // 如果有手机号码内容，则补充phoneArea
        let phoneObjectConfig = currentAnswerConfig.value.find(
          (item) => item.collectType === "phone"
        );
        let phoneCodeObjectConfig = phoneObjectConfig.ext.phoneCodeArr
          .map((item) => JSON.parse(item))
          .find((item) => +item.code === +collectInfo.value.phoneArea);
        params.phoneArea = `${phoneCodeObjectConfig.area}+${phoneCodeObjectConfig.code}`;
        params.phone = phoneCodeObjectConfig.code + collectInfo.value.phone;
      }
      collectInfo.value.email && (params.email = collectInfo.value.email);
      store.commit(
        `survey/${PUSH_ANSWER_LIST}`,
        Object.assign(currentCommonResult.value, {
          answerCollectInfo: params,
        })
      );
    },
  };
  const nextQuestion = () => {
    // 保存答案数据 更新关联
    // 校验并跳转下一题
    if (checkMap[currentType.value]()) {
      commitAnswerMap[currentResultType.value]();
      setTimeout(() => {
        store.dispatch(
          `survey/${GO_NEXT_QUESTION}`,
          currentValidQuestionIndex.value
        );
      }, 20);
    }
  };

  const prevQuestion = () => {
    store.dispatch(`survey/${BACK_PREV_QUESTION}`, prevQuestionIndex.value);
  };
  const getRealChooseArray = (answerDetail) => {
    // 根据下标取数据，恢复chooseIndex的真实下标, 不需要排序
    let resultArr = [];
    let answerChooseList = answerDetail.answerChoose;
    let questionType = answerDetail.typeName;
    answerDetail.chooseAnswerIndexArray.forEach((chooseIndex) => {
      let originIndex =
        answerDetail.answerConfigArray[chooseIndex]?.originIndex;
      let realChooseIndex = ["singleChoose", "multipleChoose"].includes(
        questionType
      )
        ? originIndex
        : chooseIndex;
      resultArr.push({
        chooseIndex: realChooseIndex,
        edit: answerChooseList[chooseIndex]?.edit,
        rowId: answerChooseList[chooseIndex]?.rowId,
      });
    });
    return resultArr;
  };
  const getRealMatrixAnswerArray = (answerDetail) => {
    // 若为矩阵，拿到选项选择情况（打乱），需要排序
    // 根据rowConfig里的originIndex恢复顺序，给answerChoose的chooseId赋值
    let answerChooseList = answerDetail.answerChoose;
    let matrixIndexArray = answerDetail.matrixAnswerIndexArray;
    let matrixRowConfigArray = answerDetail.matrixRowConfigArray;
    let originMatrixChoooseData = new Array(matrixIndexArray.length).fill({});
    matrixIndexArray.forEach((matrixChooseIndex, index) => {
      let originRowIndex = matrixRowConfigArray[index].originIndex;
      originMatrixChoooseData[originRowIndex] = {
        chooseIndex: matrixChooseIndex,
        rowId: matrixRowConfigArray[index]?.id,
        edit: answerChooseList[index]?.edit,
      };
    });
    return originMatrixChoooseData;
  };
  const commitSurvey = () => {
    // 校验本题，保存答案数据
    if (!checkMap[currentType.value]()) {
      return;
    }
    const finalIndex = questionList.value.length - 1;
    const finalQuestion = questionList.value[finalIndex];
    // 提交最后一题数据
    commitAnswerMap[currentResultType.value]();
    // 使用nextTick确保关联题目激活状态更新
    nextTick(() => {
      // 计算resultList和questionList的长度差，补充对应数量的空对象
      // 如果最后N道题都是关联题型且都没激活，需要补充N个空对象
      const resultListLength = store.state.survey.resultList.length;
      const questionListLength = questionList.value.length;
      const diffCount = questionListLength - resultListLength;
      if (diffCount > 0) {
        // 补充差集数量的空对象
        for (let i = 0; i < diffCount; i++) {
          store.commit(`survey/${PUSH_ANSWER_LIST}`, {});
        }
      }
      // 预览不提交
      if (window["isPreview"]) {
        popupState.tips = "此问卷为预览状态，不能提交";
        return;
      }
      // 玩家行为打点：完成最后一题作答，
      window.surveyDataLayer.push({
        eventName: "answer_question",
        answerStartTime: loadAnswerStartTime(),
        questionNumber: currentIndex.value + 1,
        duration: new Date() - enterQuestionTime.value,
      });
      // 处理数据, 抽离需要的部分
      let resultList = store.state.survey.resultList;
      let newList = resultList.map((item) => {
        let targetItem = {};
        if (Object.keys(item).length === 0) {
          return {}; // 处理非空对象（跳题的时候会存空对象）
        }
        targetItem.type = item.type;
        targetItem.questionKey = item.questionKey;
        targetItem.cost = item.cost;
        if (
          item.typeName === "singleChoose" ||
          item.typeName === "multipleChoose" ||
          item.typeName === "NPS"
        ) {
          targetItem.answerChoose = getRealChooseArray(item);
        }
        if (
          item.typeName === "matrixSingle" ||
          item.typeName === "matrixProgress"
        ) {
          targetItem.answerChoose = getRealMatrixAnswerArray(item);
        }
        item.typeName === "cloze" &&
          (targetItem.answerSingleEdit = item.answerSingleEdit);
        item.typeName === "messageCollect" &&
          (targetItem.answerCollectInfo = item.answerCollectInfo);
        // 针对选择题非必答未作答的情况，需处理成空对象
        if (
          targetItem.answerChoose &&
          targetItem.answerChoose.every(
            (answerItem) => +answerItem.chooseIndex === -1
          )
        ) {
          targetItem = {};
        }
        // 过滤chooseIndex为-1的答案数据：针对非必答矩阵题仅作答部分小题的情况
        targetItem.answerChoose &&
          (targetItem.answerChoose = targetItem.answerChoose.map(
            (answerItem) => {
              return answerItem.chooseIndex === -1 ? {} : answerItem;
            }
          ));
        return targetItem;
      });
      setCookie(
        "role_name",
        encodeURIComponent(getParam("role_name") || getParam("roleName")),
        1
      );
      // 请求接口
      submitQuestion(newList).then((res) => {
        if (+res.result === 1) {
          // 跳转结果页
          router.replace("/result");
          store.commit(`user/${SET_UID}`, res.data.uid);
          // 玩家行为打点：完成问卷
          window.surveyDataLayer.push({
            eventName: "finish",
            answerStartTime: loadAnswerStartTime(),
            duration: new Date() - surveyStartTime.value,
          });
        } else {
          popupState.tips = `${language.getTextByCode(res.code)}[${res.code}]`;
        }
        clearLocalData(); // 清除缓存
      });
    });
  };
  return {
    routeMap,
    nextQuestion,
    prevQuestion,
    currentComponent,
    currentValidQuestionIndex,
    prevQuestionIndex,
    commitSurvey,
    checkTips,
    currentIndex,
    questionTitleType,
    showLimitCount,
    currentAnswerConfig,
    isMultipleChooseAndLimit,
  };
}
